<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div class="flex items-center justify-center border-1 rounded-md p-3">
    @for (data of items; track data; let i = $index) {
      <div (click)="handleTabChange(i)" class="!w-[100%] flex items-center justify-center cursor-pointer px-3 py-2 rounded-md" [attr.style]="buildStyle('text', data.styles?.text, activeTab === i)">{{
        data.value.title
      }}</div>
    }
  </div>

  <div>
    @for (data of items; track data; let i = $index) {
      @if (activeTab === i) {
        <div class="w-100 px-3 py-5">
          <p
            class="m-0"
            [attr.style]="buildStyle('text', data.styles?.text)"
            [innerHTML]="data?.value?.description | lineBreak"
          ></p>
        </div>
      }
    }
  </div>
</div>
